import Y2100 from './Y2100'

export const Y210 = {
  Y2100: Y2100,
}
